import { IconCross } from '@components/icons';
import classNames from 'classnames';

import {
  BADGE_VARIANT_BLUE_SOFT,
  BADGE_VARIANT_BOTTLE_SERVICE,
  BADGE_VARIANT_DARK_GRAY,
  BADGE_VARIANT_FILL_GRAY,
  BADGE_VARIANT_GRAY,
  BADGE_VARIANT_GRAY_DISABLED,
  BADGE_VARIANT_GREEN,
  BADGE_VARIANT_GUEST_LIST,
  BADGE_VARIANT_IN_REVIEW,
  BADGE_VARIANT_INVITATION,
  BADGE_VARIANT_LIGTH_BLUE_SOFT,
  BADGE_VARIANT_ORANGE_SOFT,
  BADGE_VARIANT_PASS,
  BADGE_VARIANT_PINK_SOFT,
  BADGE_VARIANT_PURPLE_SOFT,
  BADGE_VARIANT_RED,
  BADGE_VARIANT_SCHEDULED,
  BADGE_VARIANT_SHINY_BLUE,
  BADGE_VARIANT_SOLD,
  BADGE_VARIANT_TICKET,
  BADGE_VARIANT_YELLOW,
  Props,
} from './badge.type';

export const Badge = ({ children, variant, squared, block, className, onClick, isDiscard, dataTestId }: Props) => {
  const classname = classNames(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    className,
    {
      'bg-success text-success': variant === BADGE_VARIANT_GREEN,
      'bg-critical text-critical': variant === BADGE_VARIANT_RED,
      'bg-inverse text-negative': variant === BADGE_VARIANT_DARK_GRAY,
      'fill-tertiary text-secondary': variant === BADGE_VARIANT_GRAY,
      'fill-tertiary-disabled text-secondary': variant === BADGE_VARIANT_GRAY_DISABLED,
      'fill-tertiary text-primary': variant === BADGE_VARIANT_FILL_GRAY,
      'bg-blue-soft text-blue-hard':
        variant === BADGE_VARIANT_BLUE_SOFT ||
        variant === BADGE_VARIANT_INVITATION ||
        variant === BADGE_VARIANT_SCHEDULED,
      'bg-yellow-soft text-yellow-hard': variant === BADGE_VARIANT_YELLOW,
      'bg-purple-soft text-purple-hard': variant === BADGE_VARIANT_PURPLE_SOFT,
      'bg-purple hover:bg-purple-hard text-negative': variant === BADGE_VARIANT_TICKET,
      'bg-orange hover:bg-orange-hard text-negative': variant === BADGE_VARIANT_BOTTLE_SERVICE,
      'bg-orange-soft text-orange-hard': variant === BADGE_VARIANT_ORANGE_SOFT,
      'bg-turquoise-soft text-turquoise-hard': variant === BADGE_VARIANT_PASS || variant === BADGE_VARIANT_SHINY_BLUE,
      'bg-pink-soft text-pink-hard':
        variant === BADGE_VARIANT_PINK_SOFT ||
        variant === BADGE_VARIANT_GUEST_LIST ||
        variant == BADGE_VARIANT_IN_REVIEW,
      'bg-linear-to-br from-purple to-blueDark text-white': variant === BADGE_VARIANT_SOLD,
      'bg-light-blue-soft text-light-blue-hard': variant === BADGE_VARIANT_LIGTH_BLUE_SOFT,
      'cursor-pointer': onClick,
      'cursor-default': !onClick,
      'rounded-full px-2 py-0.5': !squared && !block,
      'rounded-md px-3 py-1': squared && !block && !onClick,
      'rounded-md pl-1 pr-1 py-1': squared && !block && onClick,
      'rounded-bl-md rounded-0 p-1': block,
    },
    'inline-flex items-center shrink-0 text-action-tag-bold'
  );

  return (
    <div
      className={classname}
      onClick={onClick}
      data-testid={dataTestId ?? 'badge-container'}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : -1} // we don't need focus if no click action
      onKeyDown={(e) => e.key === 'enter' && onClick}>
      <span className='flex whitespace-nowrap'>{children}</span>
      {onClick && isDiscard && <IconCross className='w-5 h-5' variant='s' />}
    </div>
  );
};
